 /* eslint-disable */

import './Multiselectjquery.css';

import * as $ from 'jquery';

import { NavLink, Route, BrowserRouter as Router } from 'react-router-dom';
import React, { Component } from 'react';

import CryptoJS from 'crypto-js';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';

const { GoogleSpreadsheet } = require('google-spreadsheet');

 export  const  GSheetsAPIIntegrationTestFunc = async function (firstName,lastName,emailId){

  
  console.log("SHEET INTEGRATION");
  console.log("FIRST NAME :",firstName);
  console.log("LAST NAME :",lastName);
  console.log("EMAIL-ID :",emailId);

    /*
    TO CREATE SERVICE ACCOUNT MAKE USE OF THE LINK BELOW
    https://console.cloud.google.com/iam-admin/serviceaccounts
    */


 // spreadsheet key is the long id in the sheets URL
 const doc = new GoogleSpreadsheet('1tf9o56TscdKArGXHEJjmOzRmNv0EUCAAWSRXeuwoTao');


 // OR load directly from json file if not in secure environment
 await doc.useServiceAccountAuth(require('./marketingpromonationalaccount-a20f9fa647ee.json'));

 await doc.loadInfo(); // loads document properties and worksheets

 const sheet = doc.sheetsByIndex[0]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
 //console.log("SHEET TITLE :", sheet.title);
 //console.log("SHEET ROW COUNT :", sheet.rowCount);


/* var siteName = CryptoJS.AES.decrypt(localStorage.getItem('SiteName'), "shinchanbaby").toString(CryptoJS.enc.Utf8);
 var emailId = CryptoJS.AES.decrypt(localStorage.getItem('EmailId'), "shinchanbaby").toString(CryptoJS.enc.Utf8);
 var mobileNo = CryptoJS.AES.decrypt(localStorage.getItem('MobileNo'), "shinchanbaby").toString(CryptoJS.enc.Utf8);
*/
 const insertRow = await sheet.addRow({ FullName: firstName+" "+lastName,
  EmailId: emailId,MobileNo:'00' });




}

